import moment from 'moment';

export function changePwd (comp) {
    const {user} = comp.$store.state;
    if (user.expired_at) {
        const lastTipsTime = comp.$storage(true).getItem('expired-tips');
        const curMoment = moment().startOf('day');
        const expiredMoment = moment(user.expired_at).endOf('day');
        if (expiredMoment.diff(curMoment, 'day') <= 6 && (!lastTipsTime || lastTipsTime.unix < curMoment.unix())) {
            comp.$storage(true).setItem(`expired-tips`, {
                unix: curMoment.endOf('day').unix()
            });
            comp.$modal.alert({
                text: `登录成功，检测到当前账号将于${ expiredMoment.format('YYYY-MM-DD') }后失效。`
            });
        }
    }
    if (user.password_type >= 2) {
        return;
    }
    comp.$modal.alert({
        title: '更新登录密码',
        hasHTML: true,
        isHideClose: true,
        btnText: ['更新登录密码'],
        text: `
                       <div class="tips-update-pwd">
                        <p style="margin-top: 0">尊敬的用户，您好：</p>
                        <p style="line-height: 25px">根据<a target="_blank" style="color: #2196F3 ; text-decoration: underline" href="http://openstd.samr.gov.cn/bzgk/gb/newGbInfo?hcno=53282C88712CE157043B7A2C590278FC" >《信息安全 技术信息系统密码应用基本要求》（GB/T39786-2021）要求</a>和<a target="_blank" style="color: #2196F3 ;text-decoration: underline"  href="http://www.gov.cn/xinwen/2019-10/27/content_5445395.htm">《中华人民共和国密码法》</a>商用密码管理规定，现平台所有用户密码将升级为采用SM3算法加密存储</p>
                        <p style="margin-top: 0">现您登录密码还未完成修改升级，请点击“更新登录密码”完成修改。</p>
                       </div>
                    `,
        okCallback: () => {
            comp.$modal.auth({
                setting: 'password',
                title: '更新登录密码',
                isHideClose: true,
                okCallback: () => {
                    window.location.reload();
                },
            });
        }
    });
}

export const pwdCheckedReg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[·~!@#$%^&*()_+=.-]).{8,}$/;
